// Klaviyo popup language auto-select (improved observer)
function getCurrentLocale() {
    return window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';
}

(function () {

    function getKlaviyoLanguageLabel(locale) {
        switch (locale) {
            case 'es': return 'Español';
            case 'en': default: return 'English';
        }
    }

    function trySelectLanguage(form, attempt = 0) {
        const locale = getCurrentLocale();
        const label = getKlaviyoLanguageLabel(locale);
        const radio = form.querySelector(`input[type="radio"][aria-label="${label}"]`);
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            // console.log('Klaviyo language selected:', label);
        } else if (attempt < 10) {
            setTimeout(() => trySelectLanguage(form, attempt + 1), 100);
        } else {
            // console.log('Klaviyo form found, but no radio for', label, 'after multiple attempts');
        }
        // After language selection, run translation if needed
        translateKlaviyoForm(form, locale);

        // Add observer to translate on form content change
        if (!form._klaviyoTranslationObserver) {
            const observer = new MutationObserver(() => {
                translateKlaviyoForm(form, locale);
            });
            observer.observe(form, { childList: true, subtree: true });
            form._klaviyoTranslationObserver = observer;
        }
    }

    function handleKlaviyoPopup(mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        // Check if the node itself is a form
                        if (node.matches && node.matches('form[data-testid^="klaviyo-form-"]')) {
                            // console.log('Klaviyo popup form detected (direct node)', node);
                            trySelectLanguage(node);
                        }
                        // Or if it contains the form as a descendant
                        const forms = node.querySelectorAll ? node.querySelectorAll('form[data-testid^="klaviyo-form-"]') : [];
                        forms.forEach(form => {
                            // console.log('Klaviyo popup form detected (descendant)', form);
                            trySelectLanguage(form);
                        });
                    }
                });
            }
        }
    }

    // Observe the entire document for robustness
    const klaviyoPopupObserver = new MutationObserver(handleKlaviyoPopup);
    klaviyoPopupObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Run once on page load
    document.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach(form => {
        // console.log('Klaviyo popup form detected (on load)', form);
        trySelectLanguage(form);
    });

    // Klaviyo Back-in-Stock Form Translation
    function translateKlaviyoForm(form, locale) {
        if (locale !== 'es') return;
        if (!form) return;

        // Translate main heading (pre-submit and post-submit)
        const heading = form.querySelector('h1 span');
        if (heading) {
            const text = heading.textContent.trim();
            if (text === 'NOTIFY ME WHEN AVAILABLE') {
                heading.textContent = 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
            } else if (text === "YOU'RE ALL SET!") {
                heading.textContent = '¡TODO LISTO!';
            }
        }

        // Translate subheading (pre-submit and post-submit)
        const subheading = form.querySelector('div[id^="rich-text-"] > div > span, div[id^="rich-text-"] > div > div > span');
        if (subheading) {
            const text = subheading.textContent.trim();
            if (text.startsWith("We'll send you an email")) {
                subheading.textContent = 'Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.';
            } else if (text === 'Keep an eye out for a back-in-stock message.') {
                subheading.textContent = 'Estate atento a un mensaje de disponibilidad.';
            }
        }

        // Translate label
        const label = form.querySelector('label[for^="email_"]');
        if (label && label.textContent.trim() === 'Email') {
            label.textContent = 'Correo electrónico';
        }

        // Translate input placeholder
        const input = form.querySelector('input[type="email"]');
        if (input && input.placeholder === 'Enter your email') {
            input.placeholder = 'Correo electrónico';
        }

        // Translate button
        const button = form.querySelector('button[type="button"]');
        if (button && button.textContent.trim() === 'NOTIFY ME') {
            button.textContent = 'AVÍSAME';
        }
    }
})();

(function () {
    // Hide Yotpo widgets with zero reviews
    function hasZeroReviews(widget) {
        const reviewText = widget.querySelector('.yotpo-sr-bottom-line-text');
        if (!reviewText) {
            return false;
        }
        const match = reviewText.textContent.match(/(\d+)/);
        return match && parseInt(match[1], 10) === 0;
    }

    function isInProductInfo(widget) {
        return widget.closest('.product-info') !== null;
    }

    function hideZeroReviewWidgets() {
        document.querySelectorAll('.yotpo-widget-instance').forEach(widget => {
            // Exclude widgets inside .product-info
            if (isInProductInfo(widget)) return;
            if (hasZeroReviews(widget)) {
                widget.style.display = 'none';
            }
        });
    }

    function pluralizeYotpoReviewText() {
        document.querySelectorAll('.yotpo-widget-instance').forEach(widget => {
            const reviewText = widget.querySelector('.yotpo-sr-bottom-line-text');
            if (reviewText) {
                const count = parseInt(reviewText.textContent.trim(), 10);
                if (!isNaN(count)) {
                    if (Shopify.locale === 'es') {
                        reviewText.textContent = count === 1 ? '1 Reseña' : `${count} Reseñas`;
                    }
                }
            }
        });
    }

    const yotpoObserver = new MutationObserver((mutationsList) => {
        // Always check all widgets on any relevant mutation
        let foundRelevant = false;
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && (node.classList.contains('yotpo-widget-instance') || node.querySelector?.('.yotpo-widget-instance'))) {
                        foundRelevant = true;
                    }
                });
            }
            if (mutation.type === 'attributes' && mutation.target.classList.contains('yotpo-widget-instance')) {
                foundRelevant = true;
            }
        });
        if (foundRelevant) {
            setTimeout(() => {
                hideZeroReviewWidgets()
                pluralizeYotpoReviewText(); // Ensure correct pluralization after updates
            }, 500);
        }
    });

    yotpoObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
    });

    // Also check after DOMContentLoaded in case widgets are rendered late
    document.addEventListener('DOMContentLoaded', () => {
        hideZeroReviewWidgets();
        pluralizeYotpoReviewText();
    });

    document.addEventListener('recently-viewed-products:loaded', () => {
        if (yotpoWidgetsContainer) {
            setTimeout(() => {
                yotpoWidgetsContainer.initWidgets();
            }, 0);
        }
    });
})();


// live chat activation links
addEventListener("DOMContentLoaded", (event) => {
    const chatActivationLinks = document.querySelectorAll('a[href="#chat"]')
    chatActivationLinks.forEach((chatActivationLink) => {
        chatActivationLink.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            document.getElementById('ShopifyChat')?.shadowRoot?.querySelector('button.chat-toggle')?.click()
        })
    })
})

const chatObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
                if (
                    node.nodeType === 1 && node.id === 'ShopifyChat'
                ) {
                    const tryInject = () => {
                        const shadow = node.shadowRoot
                        if (shadow) {
                            const style = document.createElement('style')
                            style.textContent = `
                                .chat-toggle, .chat-app--close-button {
                                    border: 1px solid #fff !important
                                }
                            `
                            shadow.appendChild(style)

                            chatObserver.disconnect()
                        } else {
                            setTimeout(tryInject, 100)
                        }
                    }

                    tryInject()
                    chatObserver.disconnect()
                }
            }
        }
    }
})

chatObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
})

// Widget translation fetch status map
const widgetTranslationStatus = new Map(); // id => { status, retries }
const MAX_RETRIES = 3;
const BASE_DELAY = 1000; // ms

function fetchWidgetTranslation(widgetId, productHandles, widgetEl, attempt = 0) {
    widgetTranslationStatus.set(widgetId, { status: 'pending', retries: attempt });
    fetch(`/es/pages/qep?view=products-json&handles=${encodeURIComponent(productHandles.join(','))}&widget_id=${encodeURIComponent(widgetId)}`)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const el = doc.getElementById('products-json-data');
            const fetchedWidgetId = el?.dataset?.widgetId;
            const widgetElActual = document.querySelector(`[data-rebuy-id="${fetchedWidgetId}"]`);
            // console.log('Expecting widget ID:', widgetId, 'Fetched widget ID:', fetchedWidgetId);
            if (el) {
                try {
                    if (widgetElActual.dataset.translated !== 'true') {
                        const translatedProducts = JSON.parse(el.textContent);
                        widgetTranslationStatus.set(fetchedWidgetId, { status: 'success', retries: attempt });
                        setTimeout(() => {
                            updateRebuyWidgetTitles(translatedProducts, widgetElActual);
                        }, 100);
                        // console.log('Fetched translated products:', translatedProducts, widgetElActual);
                    } else {
                        // console.log(`Widget ${fetchedWidgetId} is already translated, skipping update.`);
                        widgetTranslationStatus.set(fetchedWidgetId, { status: 'skipped', retries: attempt });
                    }
                    
                    if (fetchedWidgetId !== widgetId) {
                        // console.warn(`Mismatched widget IDs: expected ${widgetId}, got ${fetchedWidgetId}. Retrying...`);
                        retryWidgetTranslation(widgetId, productHandles, widgetEl, attempt);
                    }
                } catch (e) {
                    console.error('Invalid JSON in #products-json-data:', e);
                    retryWidgetTranslation(widgetId, productHandles, widgetEl, attempt);
                }
            } else {
                console.error('Element #products-json-data not found');
                retryWidgetTranslation(widgetId, productHandles, widgetEl, attempt);
            }
        })
        .catch(error => {
            console.error('Error fetching product data:', error);
            retryWidgetTranslation(widgetId, productHandles, widgetEl, attempt);
        });
}

function retryWidgetTranslation(widgetId, productHandles, widgetEl, attempt) {
    if (attempt < MAX_RETRIES) {
        const delay = BASE_DELAY * Math.pow(2, attempt); // exponential backoff
        setTimeout(() => {
            fetchWidgetTranslation(widgetId, productHandles, widgetEl, attempt + 1);
        }, delay);
        widgetTranslationStatus.set(widgetId, { status: 'retrying', retries: attempt + 1 });
    } else {
        widgetTranslationStatus.set(widgetId, { status: 'failed', retries: attempt });
        console.error(`Widget ${widgetId} failed to fetch translations after ${MAX_RETRIES} attempts.`);
    }
}

function updateRebuyWidgetTitles(translatedProducts, widget) {
    const translationMap = {};
    const seoUrlMap = {};
    let elementTranslated = false;
    translatedProducts.forEach(product => {
        translationMap[product.handle] = product.title;
        if (product.seo_url) {
            seoUrlMap[product.handle] = product.seo_url;
        }
    });

    const rebuyWidget = widget;
    // Update .rebuy-product-image.clickable hrefs to use seo_url
    const productImageLinks = rebuyWidget.querySelectorAll('.rebuy-product-image.clickable');
    productImageLinks.forEach(imageLink => {
        const href = imageLink.getAttribute('href');
        if (href) {
            const handleMatch = href.match(/\/products\/([^?&\/]+)/);
            if (handleMatch) {
                const handle = handleMatch[1];
                const seoUrl = seoUrlMap[handle];
                if (seoUrl) {
                    imageLink.setAttribute('href', seoUrl);
                    elementTranslated = true;
                }
            }
        }
    });

    const primaryTitle = rebuyWidget.querySelector('h4.primary-title');
    if (primaryTitle) {
        const currentTitle = primaryTitle.textContent.trim();
        let spanishTitle = '';

        switch (currentTitle) {
            case 'You May Also Like':
                spanishTitle = 'También te puede gustar';
                break;
            case 'Explore our Best Sellers':
                spanishTitle = 'Explora nuestros más vendidos';
                break;
        }

        if (spanishTitle) {
            primaryTitle.textContent = spanishTitle;
            elementTranslated = true;
        }
    }

    const productTitleLinks = rebuyWidget.querySelectorAll('.rebuy-product-title a.rebuy-product-title.clickable');
    productTitleLinks.forEach(titleLink => {
        const href = titleLink.getAttribute('href');
        if (href) {
            const handleMatch = href.match(/\/products\/([^?&\/]+)/);
            if (handleMatch) {
                const handle = handleMatch[1];
                const spanishTitle = translationMap[handle];
                const seoUrl = seoUrlMap[handle];
                if (spanishTitle) {
                    const decodedTitle = decodeHtmlEntities(spanishTitle);
                    titleLink.textContent = decodedTitle;
                    if (seoUrl) {
                        titleLink.setAttribute('href', seoUrl);
                    }
                    const currentAriaLabel = titleLink.getAttribute('aria-label');
                    if (currentAriaLabel) {
                        const newAriaLabel = currentAriaLabel.replace(/View .+/, `View ${decodedTitle}`);
                        titleLink.setAttribute('aria-label', newAriaLabel);
                    }
                    // console.log(`Updated ${handle}: ${decodedTitle}`);
                    elementTranslated = true;
                }
            }
        }
    });

    const h5Titles = rebuyWidget.querySelectorAll('h5.rebuy-product-title');
    // console.log('Processing h5 titles:', h5Titles);
    h5Titles.forEach(h5 => {
        const titleLink = h5.querySelector('a.rebuy-product-title-link.clickable');
        if (titleLink) {
            // console.log('Found h5 title link:', titleLink);
            const href = titleLink.getAttribute('href');
            if (href) {
                const handleMatch = href.match(/\/products\/([^?&\/]+)/);
                if (handleMatch) {
                    const handle = handleMatch[1];
                    const spanishTitle = translationMap[handle];
                    const seoUrl = seoUrlMap[handle];
                    // console.log(`Processing ${handle}:`, { spanishTitle, seoUrl });
                    if (spanishTitle && titleLink.textContent !== spanishTitle) {
                        const decodedTitle = decodeHtmlEntities(spanishTitle);
                        titleLink.textContent = decodedTitle;
                        if (seoUrl) {
                            titleLink.setAttribute('href', seoUrl);
                        }
                        elementTranslated = true;
                    }
                }
            }
        }
    });

    const addButtons = rebuyWidget.querySelectorAll('button.rebuy-button');
    addButtons.forEach(button => {
        const buttonSpan = button.querySelector('span');
        if (buttonSpan) {
            const buttonText = buttonSpan.textContent.trim();

            if (buttonText === 'Add') {
                buttonSpan.textContent = 'Añadir';
            } else if (buttonText === 'Add to Cart') {
                buttonSpan.textContent = 'Añadir al carrito';
            }
            elementTranslated
        }

        const ariaLabel = button.getAttribute('aria-label');
        if (ariaLabel && ariaLabel.includes('Add the product,')) {
            const productBlock = button.closest('.rebuy-product-block');
            if (productBlock) {
                const productLink = productBlock.querySelector('.rebuy-product-title a.rebuy-product-title-link.clickable');
                if (productLink) {
                    const href = productLink.getAttribute('href');
                    const handleMatch = href.match(/\/products\/([^?&\/]+)/);
                    if (handleMatch) {
                        const handle = handleMatch[1];
                        const spanishTitle = translationMap[handle];
                        if (spanishTitle) {
                            const decodedTitle = decodeHtmlEntities(spanishTitle);
                            const newAriaLabel = `Añadir el producto, ${decodedTitle} al carrito`;
                            button.setAttribute('aria-label', newAriaLabel);
                        }
                    }
                }
            }
        }
    });

    if (elementTranslated) {
        rebuyWidget.setAttribute('data-translated', 'true');
    } else {
        // console.log(`No elements translated for widget ${widget.dataset.rebuyId}`);
    }

    translateRebuyButtons();
    observeButtonChanges();
}

function translateRebuyButtons() {
    const addButtons = document.querySelectorAll('.rebuy-button span');

    addButtons.forEach(buttonSpan => {
        const buttonText = buttonSpan.textContent.trim();

        switch (buttonText) {
            case 'Add':
                buttonSpan.textContent = 'Añadir';
                break;
            case 'Add to Cart':
                buttonSpan.textContent = 'Añadir al carrito';
                break;
            case 'Adding':
            case 'Adding...':
                buttonSpan.textContent = 'Añadiendo...';
                break;
            case 'Added':
            case 'Added!':
                buttonSpan.textContent = '¡Añadido!';
                break;
        }
    });
}

function observeButtonChanges() {
    const rebuyWidgets = document.querySelectorAll('[id^="rebuy-widget-"]');

    rebuyWidgets.forEach(widget => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                    const target = mutation.target;
                    const span = target.nodeType === Node.TEXT_NODE ? target.parentElement : target;

                    if (span && span.tagName === 'SPAN' && span.closest('.rebuy-button')) {
                        const text = span.textContent.trim();

                        if (text === 'Adding' || text === 'Adding...') {
                            span.textContent = 'Añadiendo...';
                        } else if (text === 'Added' || text === 'Added!') {
                            span.textContent = '¡Añadido!';
                        }
                    }
                }
            });
        });

        observer.observe(widget, {
            characterData: true,
            childList: true,
            subtree: true
        });
    });
}

function decodeHtmlEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

translateRebuyButtons();

document.addEventListener('rebuy.ready', function (event) {
    const productHandles = event.detail.widget.data.products.map(product => product.handle);
    const widgetId = event.detail.widget.data.id;
    const widgetEl = document.querySelector(`[data-rebuy-id="${widgetId}"]`);

    if (Shopify.locale && Shopify.locale !== 'en') {
        fetchWidgetTranslation(widgetId, productHandles, widgetEl);
    }

    // Add SKU and Vendor info to Rebuy widgets
    event.detail.widget.data.products.forEach((product) => {
        const widgetEl = document.querySelector(`[data-rebuy-id="${event.detail.widget.data.id}"]`)
        const productInfoEl = widgetEl.querySelector(`.product-id-${product.id} .rebuy-product-info`)
        if (productInfoEl) {
            if (!productInfoEl.querySelector('variant-sku')) {
                const skuTemplate = document.createElement("template")
                skuTemplate.innerHTML = `<variant-sku class="block text-xs text-subdued">
                    SKU: ${product.handle}
                </variant-sku>`
                const skuEl = skuTemplate.content.firstElementChild
                productInfoEl.prepend(skuEl)
            }

            if (!productInfoEl.querySelector('.link-faded')) {
                const localePrefix = Shopify.locale && Shopify.locale !== 'en' ? `/${Shopify.locale}` : ''
                const vendorTemplate = document.createElement("template")
                vendorTemplate.innerHTML = `<a href="${localePrefix}/collections/vendors?q=${product.vendor}" class="block text-xs link-faded" style="font-weight: 400">${product.vendor}</a>`
                const vendorEl = vendorTemplate.content.firstElementChild
                productInfoEl.prepend(vendorEl)
            }
        }

        // Update product links to use SEO handle if available
        const seoHandle = product?.metafields?.seo?.handle
        const productLinkEls = widgetEl.querySelectorAll(`.product-id-${product.id} .rebuy-product-image, .product-id-${product.id} .rebuy-product-title a`)

        if (seoHandle) {
            productLinkEls.forEach((productLinkEl) => {
                let productLinkQuery = ''
                let cloneLinkEl = productLinkEl.cloneNode(true)
                if (productLinkEl.href.includes('?')) {
                    productLinkQuery = `?${productLinkEl.href.split('?').slice(-1)}`
                }
                cloneLinkEl.href = `/products/${product.handle}/${seoHandle}${productLinkQuery}`
                productLinkEl.replaceWith(cloneLinkEl)
            })
        }

    })

    translateRebuyReviewsText();
    // Translate reviews text in rebuy widgets
    function translateRebuyReviewsText() {
        const reviewBlocks = event.detail.widget.template.querySelectorAll('.rebuy-product-review');
        // console.log('event.detail.widget.template:', event.detail.widget.template);
        reviewBlocks.forEach(block => {
            // console.log('Translating review block:', block);
            const countEl = block.querySelector('.rebuy-review-count-number');
            const labelEl = block.querySelector('.rebuy-review-count-label');
            if (countEl && labelEl) {
                const count = parseInt(countEl.textContent.trim(), 10);
                // console.log('Review count found:', count);
                if (!isNaN(count)) {
                    if (Shopify.locale === 'es') {
                        labelEl.textContent = count === 1 ? 'Reseña' : 'Reseñas';
                    } else {
                        labelEl.textContent = count === 1 ? 'Review' : 'Reviews';
                    }
                }
            }
        });
    }
});


(function () {
    function onSwymLoadCallback(swat) {
        let listener = function (e) {
            document.dispatchEvent(new CustomEvent("cart:refresh"))
        };

        swat.evtLayer.addEventListener('sw:movedToCartfromSFL', listener)
        swat.evtLayer.addEventListener('sw:movedAllToCartAllFromSFL', listener)
        swat.evtLayer.addEventListener('sw:addedToCartFromSharedSFL', listener)
        swat.evtLayer.addEventListener('sw:addedAllToCartFromSharedSFL', listener)
        swat.evtLayer.addEventListener('sw:storeAddedToCart', listener)
        swat.evtLayer.addEventListener('sw:storeRemovedFromCart', listener)
        swat.evtLayer.addEventListener('sw:addedtocart', listener)
        swat.evtLayer.addEventListener('sw:addedalltocart', listener)
        swat.evtLayer.addEventListener('sw:removedfromcart', listener)
    }
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(onSwymLoadCallback)
})()

// Klaviyo BIS Button Translation in buy-buttons
function translateKlaviyoBisButton(button, locale) {
    if (locale !== 'es') return;
    if (button && button.textContent.trim() === 'NOTIFY ME WHEN BACK IN STOCK') {
        button.textContent = 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
    }
}

function startKlaviyoBisButtonObserver() {
    const locale = getCurrentLocale();
    const buyButtons = document.querySelector('buy-buttons.buy-buttons');
    if (!buyButtons) return;

    // Translate any existing button on load
    const bisButton = buyButtons.querySelector('#klaviyo-bis-button-container button[type="button"]');
    if (bisButton) {
        translateKlaviyoBisButton(bisButton, locale);
    }

    // Observe for future additions
    const bisObserver = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check all added nodes
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        // Direct button container
                        if (node.id === 'klaviyo-bis-button-container') {
                            const btn = node.querySelector('button[type="button"]');
                            if (btn) translateKlaviyoBisButton(btn, locale);
                        }
                        // Or descendant button
                        const btns = node.querySelectorAll ? node.querySelectorAll('#klaviyo-bis-button-container button[type="button"]') : [];
                        btns.forEach(btn => translateKlaviyoBisButton(btn, locale));
                    }
                });
                // Also check the container itself after mutation
                const btn = buyButtons.querySelector('#klaviyo-bis-button-container button[type="button"]');
                if (btn) translateKlaviyoBisButton(btn, locale);
            }
        }
    });
    bisObserver.observe(buyButtons, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', startKlaviyoBisButtonObserver);